import { getConsentFor, onConsent } from '@guardian/libs';
import { isSwitchOn } from 'helpers/globalsAndSwitches/globals';
import { getAppliedPromo } from 'helpers/productPrice/promotions';
const periodMultipliers = {
    OneTime: 1,
    Annual: 1,
    Quarterly: 4,
    Monthly: 12,
};
export function getSubscriptionAnnualValue(productPrice, billingPeriod) {
    const fullPrice = productPrice.price;
    const promotion = getAppliedPromo(productPrice.promotions);
    /**
     * This catches the event that the SixWeekly BillingPeriod is used
     * and returns immediately. We shouldn't have to handle at runtime as the SixWeekly billing
     * period is deprecated. We should look into whether we want to retain/remove logic
     * to handle it in our code.
     */
    const periodMultiplier = periodMultipliers[billingPeriod];
    if (periodMultiplier === 0) {
        return;
    }
    const fullPriceInPence = fullPrice * 100;
    const fullAnnualPrice = fullPriceInPence * (productPrice.fixedTerm ? 1 : periodMultiplier);
    if (!promotion?.discountedPrice || !promotion.numberOfDiscountedPeriods) {
        return fullAnnualPrice;
    }
    const discountedPriceInPence = promotion.discountedPrice * 100;
    const discountInPenceCents = fullPriceInPence - discountedPriceInPence;
    const discountedAnnualPrice = fullAnnualPrice -
        discountInPenceCents * promotion.numberOfDiscountedPeriods;
    return discountedAnnualPrice;
}
export function getConvertedAnnualValue(billingPeriod, amount, sourceCurrency) {
    const annualAmount = amount * periodMultipliers[billingPeriod];
    return getConvertedValue(annualAmount, sourceCurrency);
}
export function getConvertedValue(annualAmount, sourceCurrency) {
    const valueInPence = annualAmount * 100;
    const targetCurrency = 'GBP';
    if (window.QuantumMetricAPI?.isOn()) {
        const convertedValue = window.QuantumMetricAPI.currencyConvertFromToValue(valueInPence, sourceCurrency, targetCurrency);
        return convertedValue;
    }
    return;
}
// TODO: To be deleted with the 2-step checkout
export function getContributionAnnualValue(billingPeriod, amount, sourceCurrency) {
    const valueInPence = amount * 100 * periodMultipliers[billingPeriod];
    const targetCurrency = 'GBP';
    if (window.QuantumMetricAPI?.isOn()) {
        const convertedValue = window.QuantumMetricAPI.currencyConvertFromToValue(valueInPence, sourceCurrency, targetCurrency);
        return convertedValue;
    }
    return;
}
export function waitForQuantumMetricAPi(onReady) {
    let pollCount = 0;
    const checkForQuantumMetricAPi = setInterval(() => {
        pollCount = pollCount + 1;
        if (window.QuantumMetricAPI?.isOn()) {
            onReady();
            clearInterval(checkForQuantumMetricAPi);
        }
        else if (pollCount === 10) {
            // give up waiting if QuantumMetricAPI is not ready after 10 attempts
            clearInterval(checkForQuantumMetricAPi);
        }
    }, 500);
}
export function canRunQuantumMetric() {
    // resolve immediately with false if the feature switch is OFF
    if (!isSwitchOn('featureSwitches.enableQuantumMetric')) {
        return Promise.resolve(false);
    }
    // check users consent state
    return onConsent().then((state) => {
        return getConsentFor('qm', state);
    });
}
